import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { BeaconRegionDTO } from "../BeaconRegion";
import { BeaconRegionsService } from "../beacon-regions.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { UiService } from "src/app/ui/ui.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-beacon-regions-list",
  templateUrl: "./beacon-regions-list.component.html",
  styleUrls: ["./beacon-regions-list.component.scss"],
})
export class BeaconRegionsListComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  beaconRegions!: BeaconRegionDTO[];
  columns = [
    { code: "id", name: "ID" },
    { code: "name", name: "Beacon Region Name", filter: true, selected: true },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);

  @ViewChild("beaconRegionsTable") beaconRegionsTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  hasBeaconRegionWrite: boolean = false;
  hasBeaconRegionRemove: boolean = false;
  hasBeaconRegionDetail: boolean = false;
  hasBeaconList: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  beaconRegionElementLoader!: ElementLoaderDirective;
  beaconRegionsDataSource!: BeaconRegionsDataSource;
  onFilterColumnChange = new Subject();
  perPage: number = 20;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private BeaconRegionsService: BeaconRegionsService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.beaconRegions =
    //   this.activatedRoute.snapshot.data.beaconRegions.records;
    // this.beaconRegionDataSource = new MatTableDataSource(this.beaconRegions);
    // this.beaconRegionDataSource.filterPredicate = (
    //   data: any,
    //   filter: string,
    // ) => {
    //   let found = false;
    //   for (let column of this.selectedColumns) {
    //     let rowValue = data[column];
    //     if (typeof rowValue === "number") {
    //       rowValue = rowValue.toString();
    //     }
    //     if (typeof rowValue === "string") {
    //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
    //         found = true;
    //       }
    //     }
    //   }

    //   return found;
    // };

    this.perPage = this.localStorageSvc.pageSize || 20;

    this.hasBeaconRegionWrite =
      this.activatedRoute.snapshot.data.permissions.hasBeaconRegionWrite;
    this.hasBeaconRegionRemove =
      this.activatedRoute.snapshot.data.permissions.hasBeaconRegionRemove;
    this.hasBeaconRegionDetail =
      this.activatedRoute.snapshot.data.permissions.hasBeaconRegionDetail;
    this.hasBeaconList =
      this.activatedRoute.snapshot.data.permissions.hasBeaconList;
  }

  ngAfterViewInit() {
    // this.beaconRegionsTable.renderRows();
    // this.beaconRegionDataSource.sort = this.sort;
    // this.beaconRegionDataSource.paginator = this.paginator;

    this.beaconRegionsDataSource = new BeaconRegionsDataSource(
      this.BeaconRegionsService,
      this.paginator,
      this.beaconRegionElementLoader,
    );

    this.loadBeaconRegionsPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadBeaconRegionsPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  get showDelete() {
    return this.hasBeaconRegionRemove;
  }

  get showEdit() {
    return (
      this.hasBeaconRegionWrite &&
      this.hasBeaconRegionDetail &&
      this.hasBeaconList
    );
  }

  get showCreate() {
    return this.hasBeaconRegionWrite && this.hasBeaconList;
  }

  applyFilter() {
    // this.beaconRegionDataSource.filter = this.searchValue.trim().toLowerCase();
  }

  createNewBeaconRegion() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  toggleFilterDialog() {
    this.dialog
      .open(FilterTableDialogComponent, {
        data: {
          columns: this.columns,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  edit(beaconRegion: BeaconRegionDTO) {
    this.router.navigate([beaconRegion.id], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  delete(beaconRegion: BeaconRegionDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this beacon region ( ${beaconRegion.name} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.BeaconRegionsService.deleteBeaconRegion(
                this.currentAccount!.accountID,
                beaconRegion.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Beacon Region deleted",
                );
                this.loadBeaconRegionsPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting beacon region",
                );
              },
            );
        }
      });
  }

  loadBeaconRegionsPage() {
    const sort = this.buildSort();

    return this.beaconRegionsDataSource
      .loadBeaconRegions(this.SessionService.currentAccountValue!.accountID, {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      })
      .pipe(takeUntil(this.onComponentDestroy));
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  onPageChange(e: PageEvent){
    this.paginator.pageSize = e.pageSize;
    this.localStorageSvc.pageSize = e.pageSize;
  }
}

export class BeaconRegionsDataSource implements DataSource<any> {
  private beaconRegionsSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private BeaconRegionsService: BeaconRegionsService,
    private paginator: MatPaginator,
    private beaconRegionsElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.beaconRegionsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.beaconRegionsSubject.complete();
  }

  loadBeaconRegions(masterAccountID: number, queryParams: any) {
    return this.beaconRegionsElementLoader
      .waitForEvent(
        this.BeaconRegionsService.getBeaconRegions(
          masterAccountID,
          queryParams,
        ).pipe(catchError(() => of({ count: 0, records: [] }))),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records;

          this.beaconRegionsSubject.next(records);
        }),
      );
  }

  
}
